import {
  EventEmitter
} from "events";
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'
import accountsService from "../accounts/accountsService";

class AssignmentsService extends EventEmitter {
  get(filter, from, to) {
    if (!from)
      from = 0;
    if (!to)
      to = 10;
    return TCVelikClient.GetRelative(`api/assignment/get?filter=${TCVelikClient.GetSafeFilter(filter)}&skip=${from}&take=${to}`);
  }

  assignUsers(
    userId,
    itemId,
    itemType,
    assignmentDate,
    assignmentState,
    assignmentId,
    comments,
    state = 0,
    assignmentType = "") {

    var post = {
      Id: assignmentId,
      AssignmentDueDate: assignmentDate,
      AttachmentId: itemId,
      AttachmentType: itemType,
      CreatedForUserId: userId,
      State: state,
      Comment: comments,
      AssignmentType: assignmentType
    }

    return TCVelikClient.PostRelative("api/assignment/post", post);
  }

  assignTopcReadForCurrentUser(assignmentId, itemType) {
    var profile = accountsService.getUserFromLocalStorage().user;
    var assignmentDate = new Date();
    var comments = `${profile.FirstName} read the topic and was automatically assigned as instructed.`;
    var assignmentType = "Read";

    return this.assignUsers(profile.Id, assignmentId, itemType, assignmentDate, 0, 0, comments, 0, assignmentType);
  }

  assignTopicQuizAnswer(assignmentId, itemType, succeeded) {
    var profile = accountsService.getUserFromLocalStorage().user;
    var assignmentDate = new Date();
    var comments = `${profile.FirstName} self-assessed on the topic.`;
    var assignmentType = succeeded ? "Correct Assessment" : "Incorrect Assessment";

    return this.assignUsers(profile.Id, assignmentId, itemType, assignmentDate, 0, 0, comments, 0, assignmentType);
  }

  shareEmailAssignments(
    emailsCommaSeparated,
    includeAssessmentLinks,
    includeChildren,
    itemId,
    addCurrentUserInTo,
    importance,
    workflowForEachStep) {

    addCurrentUserInTo = addCurrentUserInTo ? true : false;

    var payload = {
      EmailsCommaSeparated: emailsCommaSeparated,
      IncludeAssessmentLinks: includeAssessmentLinks,
      IncludeChildren: includeChildren,
      EmbedId: itemId,
      host: window.location.protocol + "//" + window.location.host,
      AddCurrentUserInTo: addCurrentUserInTo,
      Importance: importance,
      WorkflowForEachStep: workflowForEachStep
    }

    return TCVelikClient.PostRelative("api/assignment/SendAssignmentsToEmails", payload);
  }

  markEmailInvitation(
    id,
    isStuck,
    comment,
    workflowId, 
    workflowStepId, 
    itemId) {
    var payload = {
      Id: id,
      blocked: isStuck,
      comment: comment,
      WorkflowId: workflowId,
      WorkflowStepId: workflowStepId,
      ItemId: itemId
    }
    
    return TCVelikClient.PostRelative("api/assignment/MarkInvitation", payload);
  }

  getOtherInvitationsCountForId(id) {
    return TCVelikClient.GetRelative("api/assignment/MyOtherAccountInvitationsCount?id=" + id);
  }

  registerAttendance() {
    var profile = accountsService.getUserFromLocalStorage().user;
    var assignmentDate = new Date();
    var comments = `${profile.FirstName} attended the office.`;
    var assignmentType = "Office Clock In";

    return this.assignUsers(profile.Id, -1, 'Office Attendance', assignmentDate, 0, 0, comments, 0, assignmentType);
  }

  getOfficeAttendanceForAllEmployees() {

  }

  completeAssignment(assignment) {
    return TCVelikClient.PostRelative(`api/assignment/CompleteAssignment`, {
      Id: assignment.Id
    });
  }
}

export default new AssignmentsService();
